<ng-template #iconButtonTooltip>{{ tooltip }}</ng-template>
<ng-template #buttonContent>
  @if (!!icon) {
    <fa-icon [icon]="icon"></fa-icon>
  }
  @if (!!text) {
    <span class="button-text">{{ text }}</span>
  }
</ng-template>

@if (element === 'button') {
  <button class="tu-link" [attr.type]="buttonType"
    [attr.aria-label]="ariaLabel" [ngClass]="{'vertical': vertical}" [ngbTooltip]="iconButtonTooltip"
    (click)="buttonClick.emit()">
    <ng-container *ngTemplateOutlet='buttonContent'></ng-container>
  </button>
}

@if (element === 'link') {
  <a class="tu-link"
    [attr.aria-label]="ariaLabel" [ngClass]="{'vertical': vertical}" [ngbTooltip]="iconButtonTooltip"
    [routerLink]="routerLink" [state]="state">
    <ng-container *ngTemplateOutlet='buttonContent'></ng-container>
  </a>
}
